import { memo, type ReactNode } from 'react';

import { type SubscriptionBillingCycle } from '@air/api/types';
import { cn } from '@air/utils-tailwind';

import { formatPricePerCycle } from '~/utils/currencyFormatters';

export type CreditPackLineItemProps = {
  label: string;
  priceInCents: number;
  billingCycle: SubscriptionBillingCycle;
  description?: ReactNode;
  separator?: boolean;
  strikethrough?: boolean;
};

export const CreditPackLineItem = memo(
  ({
    label,
    priceInCents,
    billingCycle,
    description,
    separator = false,
    strikethrough = false,
  }: CreditPackLineItemProps) => {
    return (
      <div
        className={cn('flex flex-col gap-0.5', separator && 'mt-2 border-t ads:border-t-default border-t-gray-4 pt-4')}
      >
        <div className="flex items-center justify-between gap-4">
          <span className={cn('font-medium ads:text-primary text-14 text-gray-12', strikethrough && 'line-through')}>
            {label}
          </span>
          <span
            className={cn(
              'font-medium ads:text-primary text-14 text-gray-12',
              strikethrough && 'ads:text-metadata text-gray-10 line-through',
            )}
          >
            {formatPricePerCycle(priceInCents, billingCycle)}
          </span>
        </div>
        {description && <span className="ads:text-metadata text-12 text-gray-10">{description}</span>}
      </div>
    );
  },
);

CreditPackLineItem.displayName = 'CreditPackLineItem';
